export const enum FlexibleItemTypeEnum {
  BrandStoryPushItem = 'Brand Story Push Item',
  KeyFiguresItem = 'Key Figures Item',
  ParagraphItem = 'Paragraph Item',
  ProductReinsurance = 'Product Reinsurance',
  PageTeaser = 'Page Teaser',
  Callout = 'Callout'
}

export type FlexibleItemType = `${FlexibleItemTypeEnum}`;
